import type { ScheduleState } from '../types';

const selectApptsStatus = (state: ScheduleState) => state.apptsStatus;

export { selectApptsStatus };
